import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactUsService } from '../../../services/contact-us.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss',
})
export class ContactUsComponent implements OnInit {
  name!: string;
  email!: string;
  message!: string;
  Data!: FormGroup;
  fb!: FormBuilder;
  constructor(
    private _formBuilder: FormBuilder,
    private _contactUsService: ContactUsService
  ) {}

  ngOnInit() {
    this.initiate();
  }

  initiate() {
    this.Data = this._formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      message: ['', Validators.required],
    });
  }

  onSubmit() {
    // console.log(this.Data);
    this._contactUsService.addMessage(this.Data.value).subscribe({
      next: (res) => {
        console.log(res);
      },
      error: (err) => console.log(err),
    });
  }
}
